
import { invcVatExtract } from './invcVat/invcVatExtraction';
import { DocTypes, INVC_VAT } from '../docTypes';
import { payConExtraction } from './paymentConfirmation/payConExtraction';

export const extractDoc = (doc: string, type: DocTypes) => {
  if (type === INVC_VAT) return invcVatExtract(doc);
  return payConExtraction(doc);
};
